"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HIDDEN_LOGIN_FLAG = void 0;
exports.withHiddenLoginFlag = withHiddenLoginFlag;
/** Флаг «Скрытый вход» в `ml` / `ma` (официальное приложение: MemberSessionFlags.Hidden = 1). */
exports.HIDDEN_LOGIN_FLAG = 1;
/** Добавляет флаг скрытого входа в wire-параметры `ml` / `ma`, если включён. */
function withHiddenLoginFlag(params, hiddenLogin) {
    if (!hiddenLogin)
        return params;
    return [...params, exports.HIDDEN_LOGIN_FLAG];
}
